/**
 * Player colours. Colour is never the only signal (§15.5): every colour has a name and a
 * symbol, and the roster always shows the player's name. The ids match the WebSocket bots'.
 */
export interface ColourDef {
  readonly id: string;
  readonly label: string;
  readonly hex: string;
  /** A text symbol (with U+FE0E, so phones never draw it as an emoji). */
  readonly symbol: string;
}

const T = "︎";

export const COLOURS: readonly ColourDef[] = [
  { id: "crimson", label: "Crimson", hex: "#e05263", symbol: `♥${T}` },
  { id: "amber", label: "Amber", hex: "#f2a541", symbol: `☀${T}` },
  { id: "gold", label: "Gold", hex: "#e3c565", symbol: `★${T}` },
  { id: "lime", label: "Lime", hex: "#a6d85b", symbol: `♣${T}` },
  { id: "teal", label: "Teal", hex: "#3fb8af", symbol: `◆${T}` },
  { id: "sky", label: "Sky", hex: "#6cb4ee", symbol: `☁${T}` },
  { id: "indigo", label: "Indigo", hex: "#8c8cf5", symbol: `☾${T}` },
  { id: "violet", label: "Violet", hex: "#b784e8", symbol: `✿${T}` },
  { id: "rose", label: "Rose", hex: "#f28fb4", symbol: `❀${T}` },
  { id: "slate", label: "Slate", hex: "#9aa7b8", symbol: `■${T}` },
  { id: "coral", label: "Coral", hex: "#ff8466", symbol: `▲${T}` },
  { id: "mint", label: "Mint", hex: "#7ee0b5", symbol: `✚${T}` },
  { id: "plum", label: "Plum", hex: "#c26fa6", symbol: `♠${T}` },
  { id: "sand", label: "Sand", hex: "#d9c29c", symbol: `⧗${T}` },
  { id: "navy", label: "Navy", hex: "#6f8fd6", symbol: `⚓${T}` },
  { id: "olive", label: "Olive", hex: "#b5b35c", symbol: `♞${T}` },
  { id: "peach", label: "Peach", hex: "#ffb38a", symbol: `●${T}` },
  { id: "cyan", label: "Cyan", hex: "#5fd3e8", symbol: `✦${T}` },
  { id: "ruby", label: "Ruby", hex: "#d6456b", symbol: `♦${T}` },
  { id: "jade", label: "Jade", hex: "#4fbf7f", symbol: `⬢${T}` },
];

const BY_ID = new Map(COLOURS.map((c) => [c.id, c]));

/** The colour for a player's colour id; unknown ids get a neutral grey and a dot. */
export function colourOf(id: string): ColourDef {
  return BY_ID.get(id) ?? { id, label: id, hex: "#a09a90", symbol: `●${T}` };
}
